import { Outlet, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { signout, loadAccount, callDriver } from '../utilities/httpRequest';
import MenuLink from '../components/MenuLink';
import PopUpMenu from '../components/PopUpMenu';
import ImageRoundButton from '../components/ImageRoundButton';
import { HandCoins, ClipboardPlus, PhoneCall, Ambulance, ShoppingBasket } from 'lucide-react';
import AlertWindow from '../components/AlertWindow';

export default function Layout() {

    const navigate = useNavigate();

    const [account, setAccount] = useState({
        individual: {
            last_name: "",
            first_name: ""
        },
    });

    useEffect(() => { loadAccount(setAccount, navigate) }, [navigate])

    return (
        <main className="p-2 h-screen w-screen">
            <div className="flex box-border w-full h-full gap-2">
                <Menu />
                <div className="flex flex-col flex-grow gap-2">
                    <Navigation account={account} />
                    <div className="box-container grow overflow-y-auto">
                        <Outlet />
                    </div>
                </div>
            </div>
        </main>
    );
}

function Menu() {

    const [alertWindowText, setAlertWindowText] = useState("");
    const [displayAlertWindow, setDisplayAlertWindow] = useState(false);
    const [alertWindowLink,setAlertWindowLink]= useState([])

    const callDriverConfirmation = () => {
        setAlertWindowText(`<p class="font-medium">Merci de confirmer la demande de passage du chauffeur.</p><p class="italic"> À noter : lors d'une prescription en ligne, la notification de demande de passage est envoyée automatiquement. Il n'est donc pas nécessaire de refaire une demande.</p>`);
        setAlertWindowLink([{ href: callingDriver, txt: "Confirmer" },{ href: ()=>setDisplayAlertWindow(false), txt: "Fermer" }])
        setDisplayAlertWindow(true)
    }
    const callingDriver = async () => {
        setDisplayAlertWindow(false)
        try{
            document.getElementById("loading").style.display = "flex";
            await callDriver()
            setAlertWindowLink([{ href: ()=>setDisplayAlertWindow(false), txt: "Fermer" }])
            setAlertWindowText("Votre demande a bien été envoyée à nos services.")
            setDisplayAlertWindow(true)

        } catch(e) {
            setAlertWindowLink([{ href: ()=>setDisplayAlertWindow(false), txt: "Fermer" }])
            setAlertWindowText("Une erreur est survenue dans le traitement de votre demande. Veuillez recontacter nos services par mail ou par téléphone pour demander le passage d'un chauffeur.")
            setDisplayAlertWindow(true)
        } finally {
            document.getElementById("loading").style.display = "none";
        }
    }
    return (
        <>
            <AlertWindow msg={alertWindowText} links={alertWindowLink} display={displayAlertWindow} />
            <div className="box-container flex flex-col items-center min-w-max p-3">
                <Link to="/main"><img className="w-60 mb-5" src="/iconslimsvet/logo.png"
                    alt="LIMS Logo"
                /></Link>
                <div className="flex flex-col gap-4">
                    <MenuLink to="/main" icon="/iconslimsvet/home.svg" label="Accueil" />
                    <MenuLink to="demand" icon="/iconslimsvet/analyses.png" label="Mes dossiers" />
                    <MenuLink to="/new_analysis" lucide={<ClipboardPlus size={25} color="white" />} label="Nouvelle prescription" openNewTab={true} />
                    <MenuLink to="new_estimation" lucide={<HandCoins size={25} color="white" />} label="Estimation rapide" />
                    <MenuLink lucide={<Ambulance size={25} color="white" />} label="Demande de passage" onClick={callDriverConfirmation} />
                    <MenuLink to="material_order" lucide={<ShoppingBasket size={25} color="white" />} label="Commande de matériel" />
                    <MenuLink to="guide" icon="/iconslimsvet/guides_icon.svg" label="Guides" />
                    <MenuLink to="contact" lucide={<PhoneCall size={25} color="white" />} label="Contact" />
                </div>
            </div>
        </>
    );
}
function Navigation(props) {
    const navigate = useNavigate();

    const items = [
        {
            label: "Préférences/Coordonnées",
            handleClick: () => navigate("coordinate_form")
        }, {
            label: "Charte de vie privée",
            handleClick: () => { window.location.href = "https://www.limsvet.be/rgpd" }
        }, {
            label: "Conditions générales de service",
            handleClick: () => { window.location.href = "https://www.limsvet.be/cgs" }
        }, {
            label: "Se déconnecter",
            handleClick: () => signout(navigate)
        },
    ]

    const Container = () => {
        return (
            <ImageRoundButton color="bg-light-green" alt="Menu paramètres" src="/iconslimsvet/settings.png" />
        )
    }

    return (
        <div className="box-container flex justify-between items-center p-2">
            <h1 className="ml-2">Mon Espace Vet - {props.account.individual.last_name + " " + props.account.individual.first_name}</h1>
            <PopUpMenu items={items} Container={Container} />
        </div>
    );
}

